import { useQuery } from '@tanstack/react-query';
import { API } from 'common/constants/api-urls';
import { getAccountsPermissionDomain } from 'common/services/account.service';

const usePermissionsDomain = () => {
  return useQuery(
    [API.ACCOUNTS_PERMISSIONS_DOMAIN_PATH],
    getAccountsPermissionDomain
  );
};

export default usePermissionsDomain;
